import { gql } from '@apollo/client';
import React, { useMemo } from 'react';
import { Breakpoint, Constrain } from '@moda/om';
import { compact } from '@moda/portal-stanchions';
import { TrunkshowListingPageFragment } from '../../generated/types';
import { useRedirectLegacyPLPQueryParams } from '../ProductListing/useRedirectLegacyPLPQueryParams';
import { Loading } from '../Loading';
import { TRUNKSHOW_CELL_FRAGMENT, LazyGrid, TrunkshowCell, GridLoading } from '../Grid';
import { PAGE_FILTER_NAME_SLUG_FACET_FRAGMENT } from '../PageFilter';
import { PageMeta } from '../PageMeta';
import { TrunkshowListingDesktop } from './TrunkshowListingDesktop';
import { TrunkshowListingMobile } from './TrunkshowListingMobile';

import './TrunkshowListing.scss';

export const TRUNKSHOW_LISTING_PAGE_FRAGMENT = gql`
  fragment TrunkshowListingPageFragment on TrunkshowCollectionResult {
    trunkshows(all: true, sort: $sort) {
      edges {
        node {
          id
          ...TrunkshowCellFragment
        }
      }
    }
    designers {
      ...PageFilterNameSlugFacetFragment
    }
    categories {
      ...PageFilterNameSlugFacetFragment
    }
  }
  ${TRUNKSHOW_CELL_FRAGMENT}
  ${PAGE_FILTER_NAME_SLUG_FACET_FRAGMENT}
`;

interface TrunkshowListingProps {
  queryResult?: TrunkshowListingPageFragment | null;
  loading: boolean;
  title: string;
  description: string;
}

export const TrunkshowListing: React.FC<TrunkshowListingProps> = ({
  queryResult,
  loading,
  title,
  description
}) => {
  useRedirectLegacyPLPQueryParams();

  const trunkshows = useMemo(
    () => compact(queryResult?.trunkshows?.edges?.map(edge => edge?.node)),
    [queryResult]
  );

  if (!queryResult) return <Loading />;

  const content = (
    <div className="TrunkshowListing__content">
      <LazyGrid>
        {trunkshows
          .filter(trunkshow => !trunkshow.seasonName.toLowerCase().startsWith('special'))
          .map(trunkshow => (
            <TrunkshowCell key={trunkshow.id} trunkshow={trunkshow} />
          ))}
      </LazyGrid>

      <GridLoading show={loading} />
    </div>
  );

  return (
    <>
      <PageMeta title={title} description={description} />
      <Constrain>
        <Breakpoint gt="md">
          <TrunkshowListingDesktop queryResult={queryResult}>{content}</TrunkshowListingDesktop>
        </Breakpoint>
        <Breakpoint lt="md">
          <TrunkshowListingMobile queryResult={queryResult}>{content}</TrunkshowListingMobile>
        </Breakpoint>
      </Constrain>
    </>
  );
};
